/* eslint-disable import/prefer-default-export */

export const clearEmptyFields = (object) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const key in object) {
    if ((object[key] === '' || !object[key]) && typeof object[key] !== typeof true) {
      delete object[key];
    }
  }
  return object;
};
